import { SoftwareLicense } from '@/client'

export function isDeprecatedPlaceholderValue(
  value: string | null | undefined
): boolean {
  if (!value) {
    return true
  }

  const normalizedValue = value.trim().toLowerCase()

  if (!normalizedValue) {
    return true
  }

  return (
    normalizedValue === 'placeholder' ||
    normalizedValue === 'null' ||
    normalizedValue === 'undefined'
  )
}

export function buildSoftwareLicenseMap(
  softwareLicenses: SoftwareLicense[]
): Map<string, SoftwareLicense> {
  const softwareLicensesById = new Map<string, SoftwareLicense>()

  for (const softwareLicense of softwareLicenses) {
    softwareLicensesById.set(softwareLicense._id, softwareLicense)
  }

  return softwareLicensesById
}

export function resolveSoftwareLicenseName(
  softwareLicenseId: string,
  softwareLicensesById: Map<string, SoftwareLicense>
): string {
  const softwareLicense = softwareLicensesById.get(softwareLicenseId)

  if (!softwareLicense) {
    return softwareLicenseId
  }

  if (!isDeprecatedPlaceholderValue(softwareLicense.name)) {
    return softwareLicense.name
  }

  if (!isDeprecatedPlaceholderValue(softwareLicense.external_name)) {
    return softwareLicense.external_name
  }

  return softwareLicenseId
}
